import React, { useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/apiConfig';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Box } from '@mui/material';

const AddObjectDialog = ({ open, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    objektkuerzel: '',
    objektstrasse: '',
    objekthausnummer: '',
    objektplz: '',
    objektort: '',
    objektkaufdatum: '',
    objektkaufpreis: '',
    objektgebaeudeanteilprozent: '',
    baujahr: '',
    modernisierung_jahr: '',
    modernisierung_art: ''
  });

  // Handler für Änderungen in den Eingabefeldern
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handler für das Speichern
  const handleSave = async () => {
    try {
      // REST-konformes Anlegen
      const response = await axios.post(getApiUrl('/api/objects'), formData);
      console.log('Neues Objekt gespeichert:', response.data);

      onSave(response.data); // Optional: Callback mit den gespeicherten Daten aufrufen
      onClose(); // Dialog schließen
    } catch (error) {
      console.error("Fehler beim Speichern des Objekts:", error);
      alert("Fehler beim Speichern des Objekts");
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Neues Objekt anlegen</DialogTitle>
      <DialogContent>
        <Box my={2}>
          <TextField
            label="Kürzel"
            name="objektkuerzel"
            value={formData.objektkuerzel}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Straße"
            name="objektstrasse"
            value={formData.objektstrasse}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Hausnummer"
            name="objekthausnummer"
            value={formData.objekthausnummer}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Postleitzahl"
            name="objektplz"
            value={formData.objektplz}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Ort"
            name="objektort"
            value={formData.objektort}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Kaufdatum"
            name="objektkaufdatum"
            value={formData.objektkaufdatum}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Kaufpreis"
            name="objektkaufpreis"
            value={formData.objektkaufpreis}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Gebäudeanteil in % für AfA"
            name="objektgebaeudeanteilprozent"
            value={formData.objektgebaeudeanteilprozent}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Baujahr"
            name="baujahr"
            type="number"
            value={formData.baujahr}
            onChange={handleChange}
            fullWidth
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Modernisierungsjahr (optional)"
            name="modernisierung_jahr"
            type="number"
            value={formData.modernisierung_jahr}
            onChange={handleChange}
            fullWidth
            helperText="Jahr der letzten wesentlichen Modernisierung"
          />
        </Box>
        <Box my={2}>
          <TextField
            label="Modernisierungsart (optional)"
            name="modernisierung_art"
            value={formData.modernisierung_art}
            onChange={handleChange}
            fullWidth
            helperText="z.B. Neue Heizung, Fenster, Badezimmer"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Abbrechen
        </Button>
        <Button onClick={handleSave} color="primary" variant="contained">
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddObjectDialog;
